import { render, staticRenderFns } from "./MedicalCertificate.vue?vue&type=template&id=629a6e76&scoped=true"
import script from "./MedicalCertificate.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629a6e76",
  null
  
)

export default component.exports